import { useState } from 'react'
import { Card, Form, Input, Button, message } from 'antd'
import { PhoneOutlined, LockOutlined } from '@ant-design/icons'
import { useNavigate, Link } from 'react-router-dom'
import axios from 'axios'

const request = axios.create({ baseURL: '/api', timeout: 30000 })
request.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error)
)

function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [sending, setSending] = useState(false)
  const navigate = useNavigate()
  const [form] = Form.useForm()

  // 发送验证码
  const sendCode = async () => {
    try {
      const phone = form.getFieldValue('phone')
      if (!phone) {
        message.warning('请先输入手机号')
        return
      }
      setSending(true)
      const res: any = await request.post('/sms/send-code', { phone })
      if (res.code === 200) {
        message.success('验证码已发送')
      } else {
        message.error(res.message || '发送失败')
      }
    } catch (error: any) {
      console.error('发送验证码失败:', error)
      message.error(error.response?.data?.message || '发送失败')
    } finally {
      setSending(false)
    }
  }

  // 重置密码
  const onFinish = async (values: { phone: string; code: string; newPassword: string }) => {
    setLoading(true)
    try {
      const res: any = await request.post('/sms/reset-password', {
        phone: values.phone,
        code: values.code,
        newPassword: values.newPassword
      })

      if (res.code === 200) {
        message.success('密码重置成功，请使用新密码登录')
        navigate('/login')
      } else {
        message.error(res.message || '重置失败')
      }
    } catch (error: any) {
      console.error('重置密码失败:', error)
      message.error(error.response?.data?.message || '重置失败')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #55266c 0%, #7c3a8f 100%)'
    }}>
      <Card style={{ width: 400, borderRadius: 8 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img 
            src="/logo.jpg" 
            alt="智厨云" 
            style={{ width: 60, height: 60, marginBottom: 16, borderRadius: 8 }}
            onError={(e) => {
              e.currentTarget.style.display = 'none'
            }}
          />
          <h2 style={{ margin: 0, color: '#55266c' }}>忘记密码</h2>
          <p style={{ color: '#666', marginTop: 8 }}>通过手机验证码重置密码</p>
        </div>
        
        <Form
          form={form}
          name="forgot-password"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="phone"
            rules={[
              { required: true, message: '请输入手机号' },
              { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确' }
            ]}
          >
            <Input 
              prefix={<PhoneOutlined />} 
              placeholder="手机号" 
            />
          </Form.Item>

          <Form.Item
            name="code"
            rules={[{ required: true, message: '请输入验证码' }]}
          >
            <Input
              prefix={<LockOutlined />}
              placeholder="验证码"
              suffix={
                <Button 
                  type="link" 
                  size="small" 
                  loading={sending}
                  onClick={sendCode}
                  style={{ padding: 0, height: 'auto' }}
                >
                  {sending ? '发送中...' : '获取验证码'}
                </Button>
              }
            />
          </Form.Item>

          <Form.Item
            name="newPassword"
            rules={[
              { required: true, message: '请输入新密码' },
              { min: 6, message: '密码至少6位' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="新密码（至少6位）"
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: '请确认密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject(new Error('两次密码不一致'))
                }
              })
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="确认新密码"
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading}
              block
              style={{ backgroundColor: '#55266c' }}
            >
              重置密码
            </Button>
          </Form.Item>
        </Form>
        
        <div style={{ textAlign: 'center' }}>
          <Link to="/login" style={{ color: '#55266c' }}>返回登录</Link>
        </div>
      </Card>
    </div>
  )
}

export default ForgotPassword
